export default __webpack_public_path__ + "static/media/lock.422347a8.svg";